export default __webpack_public_path__ + "static/media/chatgpt.d692b862.svg";